export enum ChartType {
  DELIVERY_NOTES_PER_DAY = 'DELIVERY_NOTES_PER_DAY',
  DELIVERY_NOTES_COUNT = 'DELIVERY_NOTES_COUNT',
  DELIVERY_NOTES_PER_DAY_PER_DRIVER = 'DELIVERY_NOTES_PER_DAY_PER_DRIVER',
  DELIVERY_NOTES_COUNTER_TOTAL = 'DELIVERY_NOTES_COUNTER_TOTAL',
  DELIVERY_NOTES_COUNTER_EMPLOYEES = 'DELIVERY_NOTES_COUNTER_EMPLOYEES',
  DELIVERY_NOTES_COUNTER_VEHICLES = 'DELIVERY_NOTES_COUNTER_VEHICLES',
  DELIVERY_NOTES_COUNTER_WORKING_DAYS = 'DELIVERY_NOTES_COUNTER_WORKING_DAYS'
}

enum ResumeType {}

enum SerieName {
  High = 'high',
  Low = 'low',
  Open = 'open',
  Close = 'close',
  Median = 'median'
}

interface Serie {
  name: string
  data: number[]
  xAxis: string[]
}

interface Chart {
  type: ChartType
  series: Serie[]
}

interface Statistics {
  charts: Chart[]
}

export type { Chart, ResumeType, Serie, SerieName, Statistics }
